<template>
  <total-quote-items :quote-distribution="quoteDistribution" />
</template>

<script>
import TotalQuoteItems from '@/views/components/quote-distribution-components/TotalQuoteItems.vue'

export default {
  name: 'AskView',
  components: {
    TotalQuoteItems,
  },
  computed: {
    quoteDistribution() {
      return this.$store.state[this.MODULE_NAME].quoteDistribution
    },
  },
  created() {
    this.$store.dispatch(`${this.MODULE_NAME}/getQuoteDistribution`, this.$route.params.totalQuoteId)
  },
  setup() {
    const MODULE_NAME = 'quoteDistributionOtm'
    return {
      MODULE_NAME,
    }
  },
}
</script>

<style scoped>

</style>
